export const columnStateMapping = {
  registered: ['registered'],
  qualifying: [
    'qualifying',
    'qualifying_client_changes_requested',
    'qualifying_quote_client_review',
    'qualifying_review',
    'qualifying_quote',
  ],
  deploying: ['deploying', 'deploying_management_review'],
}

export type ColumnKey = keyof typeof columnStateMapping
